import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import PageTab from "./PageTab";

const EditPage = () => {
  const { slug } = useParams();

  return (
    <div className="flex-1 p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold">📝 Edit Page Details</h1>
        <Link to="/admin/pages">
          <Button
            variant="outline"
            className="hover:bg-blue-600 hover:text-white"
            aria-label="Back to Pages"
          >
            Back to Pages →
          </Button>
        </Link>
      </div>

      {slug ? (
        <PageTab slug={slug} />
      ) : (
        <p className="text-red-500">Error: Page slug not found.</p>
      )}
    </div>
  );
};

export default EditPage;
